import React from 'react'
import './experience.css'
import {BsPatchCheckFill} from 'react-icons/bs'
const Experience = () => {
  return (
    <section id='experience'>
      <h5>What Skills I have</h5>
      <h2>My Skills</h2>
      <div className="container experience__container">
        <div className="experience__frontend">
          <h3>Frontend Development</h3>
          <div className="experience__content">
            <article className="experience__details">
              <BsPatchCheckFill  className='experience__details-icon' />
              <div>
                <h4>HTML/CSS</h4>
              </div>
            </article>
            <article className="experience__details">
              <BsPatchCheckFill  className='experience__details-icon' />
              <div>
                <h4>JavaScript</h4>
              </div>
            </article>
            <article className="experience__details">
              <BsPatchCheckFill  className='experience__details-icon' />
              <div>
                <h4>MateriL-UI</h4>
              </div>
            </article>
            <article className="experience__details">
              <BsPatchCheckFill  className='experience__details-icon' />
              <div>
                <h4>ReactJS</h4>
              </div>
            </article>
          </div>
        </div>
        <div className="experience__backend">
        <h3>Backend Development</h3>
        <div className="experience__content">
            <article className="experience__details">
              <BsPatchCheckFill  className='experience__details-icon' />
              <div>
                <h4>Python (Django, Flask)</h4>
              </div>
            </article>
            <article className="experience__details">
              <BsPatchCheckFill  className='experience__details-icon' />
              <div>
                <h4>NodeJS</h4>
              </div>
            </article>
            <article className="experience__details">
              <BsPatchCheckFill  className='experience__details-icon' />
              <div>
                <h4>SQL Databases (MySQL, PostGreSQL)</h4>
              </div>
            </article>
            <article className="experience__details">
              <BsPatchCheckFill  className='experience__details-icon' />
              <div>
                <h4>MongoDB</h4>
              </div>
            </article>
            <article className="experience__details">
              <BsPatchCheckFill  className='experience__details-icon' />
              <div>
                <h4>JavaScript</h4>
              </div>
            </article>
            <article className="experience__details">
              <BsPatchCheckFill  className='experience__details-icon' />
              <div>
                <h4>Linux Systems</h4>
              </div>
             
            </article>
            
          </div>
        </div>
        <div className="experience__backend">
        <h3>Embeded Systems Development</h3>
        <div className="experience__content">
            <article className="experience__details">
              <BsPatchCheckFill  className='experience__details-icon' />
              <div>
                <h4>Arduino IDE</h4>
              </div>
            </article>
            <article className="experience__details">
              <BsPatchCheckFill  className='experience__details-icon' />
              <div>
                <h4>ESP32</h4>
              </div>
            </article>
            <article className="experience__details">
              <BsPatchCheckFill  className='experience__details-icon' />
              <div>
                <h4>MATLAB</h4>
              </div>
            </article>
            <article className="experience__details">
              <BsPatchCheckFill  className='experience__details-icon' />
              <div>
                <h4>Embedded C</h4>
              </div>
            </article>
            <article className="experience__details">
              <BsPatchCheckFill  className='experience__details-icon' />
              <div>
                <h4>Raspberry Pi</h4>
              </div>
            </article>
            <article className="experience__details">
              <BsPatchCheckFill  className='experience__details-icon' />
              <div>
                <h4>Linux Systems</h4>
              </div>
             
            </article>
            
          </div>
        </div>
      </div>
    </section>
  )
}

export default Experience